/**
 * Normalize API/wire payloads to camelCase so SDK types (camelCase only) are satisfied.
 * Call after response.json() when the backend may return snake_case.
 */

function snakeToCamel(s: string): string {
  return s.replace(/_([a-z])/g, (_, c) => c.toUpperCase());
}

function isPlainObject(v: unknown): v is Record<string, unknown> {
  return typeof v === "object" && v !== null && !Array.isArray(v) && (v as object).constructor === Object;
}

/**
 * Recursively converts object keys from snake_case to camelCase.
 * Arrays and nested objects are processed; primitives and Date are returned as-is.
 */
export function normalizeSnakeToCamel<T = unknown>(value: unknown): T {
  if (value === null || value === undefined) {
    return value as T;
  }
  if (Array.isArray(value)) {
    return value.map((item) => normalizeSnakeToCamel(item)) as T;
  }
  if (isPlainObject(value)) {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value)) {
      const camelKey = snakeToCamel(k);
      out[camelKey] = normalizeSnakeToCamel(v);
    }
    return out as T;
  }
  return value as T;
}
